export const AUD_DESKTOP_MENU = 'aud_desktop_bx606_new_head_menu';

export const EXPERIMENTS = [AUD_DESKTOP_MENU];
